export default __webpack_public_path__ + "static/media/star.eefd6982.svg";